export const SET_ERROR = 'SET_ERROR';
export const SET_OK = 'SET_OK';
export const RESET_ALERT = 'RESET_ALERT';

const ToastReducer = (state, action) => {
  const { payload, type } = action;

  switch (type) {
    case SET_OK:
      return {
        ...payload
      };
    case SET_ERROR:
      return {
        error: true,
        ...payload
      };
    case RESET_ALERT:
      return null;
    default:
      return state;
  }
};

export default ToastReducer;
